// ════════════════════════════════════════════════════════════════
// DATABASE — Dexie.js (IndexedDB) Schema
// ════════════════════════════════════════════════════════════════
// Generic schema that works for ALL niche deployments. The entity
// labels come from AppConfig; the table structure is universal.
// ════════════════════════════════════════════════════════════════

import Dexie, { type Table } from 'dexie';
import type {
  Collection,
  Item,
  Identifier,
  LedgerEntry,
  Tag,
  TagAssignment,
  AppMeta,
} from '../types';

export class VaultDatabase extends Dexie {
  collections!: Table<Collection, string>;
  items!: Table<Item, string>;
  identifiers!: Table<Identifier, string>;
  ledgerEntries!: Table<LedgerEntry, string>;
  tags!: Table<Tag, string>;
  tagAssignments!: Table<TagAssignment, string>;
  appMeta!: Table<AppMeta, string>;

  constructor() {
    super('ColdVaultLedger');

    // Version 1 — Initial schema
    // Indexes are defined here for queryable fields.
    // Encrypted fields are NOT indexed (they're ciphertext).
    this.version(1).stores({
      collections: 'id, name, category, manufacturer, createdAt',
      items: 'id, collectionId, name, symbol, createdAt',
      identifiers: 'id, itemId, isPrimary, createdAt',
      ledgerEntries: 'id, collectionId, itemId, entryType, date',
      tags: 'id, name',
      tagAssignments: 'id, tagId, entityId, entityType',
      appMeta: 'key',
    });
  }
}

// Singleton instance — imported throughout the app
export const db = new VaultDatabase();
